



<form [formGroup]="authForm" class="auth-form">

  <mat-form-field>
    <mat-label>Compte</mat-label>
    <input type="text" matInput placeholder="" formControlName="username">
  </mat-form-field>

  @if (!recoverMode) {
    <mat-form-field>
      <mat-label>Mot de passe</mat-label>
      <input type="password" matInput placeholder="" formControlName="password" [required]="!recoverMode">
    </mat-form-field>
  }

  @if (!recoverMode && signupMode) {
    <h6>
      <mat-label>Dealer Type</mat-label>
      <mat-radio-group
        aria-labelledby="example-radio-group-label" class="example-radio-group" formControlName="dealerType">
        @for (type of dealerTypes; track type; let i = $index) {
          <mat-radio-button class="example-radio-button"  [value]="type">
            {{type}}
          </mat-radio-button>
        }
      </mat-radio-group>
    </h6>
  }

  <h6 style="color: orange">{{( authFeedback$ | async) }}</h6>

  @if ((fetching$ | async)) {
    <h6 style="text-align:center">
      <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
    </h6>
  }

  @if (!recoverMode) {
    <div class="simple-button">
      <button mat-button class="cta-button" [disabled] = !authForm.valid type="submit" (click)="submitAuthForm()">
        {{signupMode ? "signup"  : "login" }}
      </button>
    </div>
  }
  @if (recoverMode) {
    <div >
      <button mat-button class="simple-button" [disabled]="!authForm.controls['username'].valid" type="submit" (click)="submitRecoverForm()">
        recover password
      </button>
    </div>
  }

  @if (!recoverMode) {
    <h6>
      {{signupMode ? "Already registered ?" : "Not registered yet ?" }}
      <button  (click) = "toggleSignupMode()"  mat-button class="simple-button" >
        {{signupMode ? "login"  : "signup" }}
      </button>
    </h6>
  }

  <h6> {{recoverMode ? "Already registered or signup ?"  : "Lost your password ?" }}
    <button  (click) = "toggleRecoverMode()" mat-button class="simple-button">
      {{recoverMode ? "login or signup"  : "recover password" }}
    </button>
  </h6>
</form>

